import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { exportLeadsToCSV } from '../../utils/LeadsExportCSV';

const LeadsIntroActions = ({ leads }) => {
  return (
    <div className="admin-page__intro_actions">
      <button onClick={() => exportLeadsToCSV(leads)}>
        <FontAwesomeIcon icon={faFileExport} /> Export
      </button>
    </div>
  );
};

export default LeadsIntroActions;